const TEXT = {
    APPLY_INDEX_TITLE_1:"申请代理",
    apply_menus:[
        {
        id:'1',
        ico:'1',
        name:'基本资料',
        url:'/apply',
        class:'now'
        },
        {
        id:'2',
        ico:'2',
        name:'证件上传',
        url:'/step2',
        class:''
        },
        {
        id:'3',
        ico:'3',
        name:'授权申请',
        url:'/step3',
        class:''
        },
        {
        id:'4',
        ico:'4',
        name:'保证金',
        url:'/step4',
        class:''
        },
        {
        id:'5',
        ico:'5',
        name:'成为代理商',
        url:'/step5',
        class:''
        },
    ],
};
export {
	TEXT
}



// WEBPACK FOOTER //
// ./src/config/page/cn/apply/index.js